module.exports = __webpack_public_path__ + "img/1707036430902-a-rain.php.b409bc50.webp";